import { AppRouteProps } from "@harea/component"
import React from "react"
import { DetailContractRoutes } from "views/details/DetailContractRoutes"
import { AvenantRoutes } from "views/avenant/AvenantRoutes"
import { CreateContractRoutes } from "views/create/CreateContractRoutes"

const ListContractContainer = React.lazy(() => import("./container/ListContractContainer"))

export const ContractRoutes: Array<AppRouteProps> = [
    {
        path: "contracts",
        title: "Harea.Contract.List.Title",
        element: <ListContractContainer />,
        roles: ["CONTRACT", "CONTRACT_CREATE"],
        children: [
            ...CreateContractRoutes
        ]
    },
    ...DetailContractRoutes,
    ...AvenantRoutes,
]
